import { leadLazyLoad } from 'utils/loadable';

export const ScreenShareContentNotFound = leadLazyLoad(
  () => import('./ScreenShareContentNotFoundPage'),
  module => module.ScreenShareContentNotFoundPage,
);
